module.exports = __webpack_public_path__ + "img/case_07.319fb649.jpg";